












































import flagKeys from '@/constants/flagKeys';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class WelcomeCoinsIcon extends Vue {
  @Prop({ default: '48' }) readonly width?: string;
  @Prop({ default: '48' }) readonly height?: string;
  @Prop({ default: '#8D949E' }) readonly fill?: string;

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get newIconCoinFlag() {
    return this.flags.includes(flagKeys.newCoinIcon);
  }
}
